export const label = {
    'Film_Title' : 'title',
    'Resolution' : 'nature of source',
    'Resolution Scanned':'resolution',
    'Input Format/Medium' : 'input format',
    'Delivery Format/Medium' : 'output format',
    'Film Element':'film Type'
}

export const BaseGrade_DM_metadata = [
    'Film_Title',
    'Client',
    'Language',
    'Resolution',
    'Film Element',
    'Film Gauge',
    'Aspect Ratio',
    'Censor Certificate',
   'Resolution Scanned',
   'Input Format/Medium',
   'Delivery Format/Medium', 
  ]
   export interface DmFramesReel {
    uuid: string;
    "Reel No": string;
    "Total Frames": string;
    "Actual Frames": string;
    "Data Size": string;
    "Noticeable Remarks in Color Reproduction": string;
  }
  
  export interface Temp {
    body: DmFramesReel[];
  }